export { default } from './BadgeVersion';
